// Tichý stav načítání: prázdná plocha, která nebliká. Malý indikátor se ukáže až po prodlevě
// (výchozí 300 ms), takže rychlá odpověď serveru nic nezobrazí a stránka jen „naskočí“.
import { useEffect, useState } from 'react';
import './TichyStav.css';

interface Props {
  /** Text indikátoru po prodlevě. */
  text?: string;
  /** Po kolika ms indikátor ukázat. */
  prodlevaMs?: number;
  /** Tmavá plocha (přihlášení) místo pozadí stránky. */
  tmavy?: boolean;
}

export function TichyStav({ text = 'Načítám…', prodlevaMs = 300, tmavy = false }: Props) {
  const [viditelny, setViditelny] = useState(false);

  useEffect(() => {
    const casovac = window.setTimeout(() => setViditelny(true), prodlevaMs);
    return () => window.clearTimeout(casovac);
  }, [prodlevaMs]);

  return (
    <div
      className={`tichy-stav${tmavy ? ' tichy-stav--tmavy tema-tmavy' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {viditelny && (
        <span className="tichy-stav__indikator">
          <span className="tichy-stav__tecka" aria-hidden="true" />
          {text}
        </span>
      )}
    </div>
  );
}
